// extracted by mini-css-extract-plugin
export default {"home":"Home_home__2emqZ","home--product":"Home_home--product__22w-b"};